/*
 * @Author: wangyang
 * @Date: 2021-11-01 13:09:44
 * @LastEditTime: 2023-10-07 10:31:07
 * @LastEditors: gaojinyu 1593026814@qq.com
 * @Description: 接口统计定义
 * @FilePath: \north\src\api\api.js
 */
import http from '../utils/http';
// 接口统计定义
let api = {
  // 圣大水肥机接口
  // 登录
  sfLogin: function (params) {
    return http.post(`/shuifei/api/v1/login`, params);
  },
  // 获取设备状态
  sfGetStatus: function (params, headers) {
    return http.get(`/shuifei/api/v1/dev/value`, params, headers);
  },
  // 设置设备状态
  sfSetStatus: function (params, headers) {
    return http.post(`/shuifei/api/v1/dev/SetProperty`, params, headers);
  },
  // 仁科环境监测
  getLatestData: function (number) {
    return http.get(`/business/greenhouse/getLatestData?number=` + number);
  },
  // 仁科继电器状态
  getDeviceState: function (number) {
    return http.post(`/renke/js/relay/state?deviceAddr=` + number);
  },
  // 仁科继电器开关控制
  setDeviceState: function (deviceAddr, relayID, opt) {
    return http.post(`/renke/js/relay/control?deviceAddr=${deviceAddr}&relayID=${relayID}&opt=${opt}`);
  },

  // 傲农风机
  ansetControl: function () {
    return http.post(`/aonong/eds/blowers/setControl`);
  },
  angetParameter: function () {
    return http.post(`/aonong/eds/blowers/getParameter`);
  },
  ansetParameter: function () {
    return http.post(`/aonong/eds/blowers/setParameter`);
  },
  angetData: function () {
    return http.post(`/aonong/eds/blowers/getData`);
  },






  // 获取气象数据
  getWeatherData: function (params) {
    return http.post(`/js/weather/weatherStation/feign/weather-forecast`, params);
  },
  // 环境温度
  getTemperatureData: function (params) {
    return http.post(`/js/weather/weatherHistory/feign/temperature/list`, params)
  },
  // 累计积温
  getAccumlatedData: function (params) {
    return http.post(`/js/weather/weatherHistory/feign/activeAccumulatedTemperature/list`, params)
  },
  // 玉米接口
  getWarningByYuMi: function (params) {
    return http.post(`/js/crop/cropGrowthWarning/feign/getWarningByYuMi`)
  },
  // 园区平台气象站数据
  getWeatherStationData(params){
    return http.get(`/business/weatherStation/getLatestData`, params)
  },
  // 虫情测报灯
  getInsectData(deviceAddr) {
    return http.post(`/js/insect/feign/getInsectData?deviceAddr=${deviceAddr}`)
  },
  // 杀虫灯
  getInsectLampData(deviceAddr) {
    return http.post(`/js/insect/feign/getInsectLampData?deviceAddr=${deviceAddr}`)
  },
  // 土壤墒情
  getSoilMoistureCurveData(deviceAddr) {
    return http.post(`/js/soil/soilMoisture/feign/getCurrentDataByRenKe?deviceAddr=${deviceAddr}`)
  },
  // 虫情图片
  getPictureListByMonth(time) {
    return http.get(`/js/insect/insectPrediction/feign/getPictureListByMonth?recordTime=${time}`)
  },
  // 虫害统计
  getPestStatisticsData() {
    return http.get(`/js/insect/insectPrediction/feign/getListByTypeAndYear?officeCode=tieling`)
  },
  // 测报灯实时图片
  getPictureCbLamp(deviceAddr) {
    return http.get(`/js/insect/insectPrediction/feign/getCurrentPictureByRenKe?deviceAddr=${deviceAddr}`)
  },
  // 测报灯信息
  getInfoCbLamp() {
    return http.get(`/js/insect/insectPrediction/feign/getLatestData?officeCode=tieling`)
  },
  // 获取作业详情列表
  getCarDataWorkByDay(carId) {
    return http.get(`http://39.107.152.122/fm/app/api/v1/workByDay/listData/carIds?carId=${carId}`)
  },
  getWorkDetailsByDate(carId, starttime) {
    return http.get(`http://39.107.152.122/fm/app/api/v1/workDetail/listData?carId=${carId}&starttime=${starttime}`)
  },
  // 获取作业轨迹数据
  getWorkTraceData(carId, time) {
    return http.get(`http://39.107.152.122/fm/gps/findByCarId?carId=${carId}&beginTime=${time}%2000:00:00&endTime=${time}%2023:59:59`)
  },
  // 获取经纬度最新一条
  getGpsLastData(carId) {
    return http.get(`http://zhinong.lecyon.com:8081/es/findLastData/byCarId?carId=${carId}`)
  },
  // 获取作业图像数据
  getPictureInMap(carId, time) {
    return http.get(`http://39.107.152.122/fm/fmPic/pictureInMap?carId=${carId}&beginTime=${time}%20000:00:00&endTime=${time}%2023:59:59`)
  },
  // 获取主机信息
  getCarInfo(carId) {
    return http.get(`http://39.107.152.122/fm/app/install/api/carInfo?carId=${carId}`)
  },
  // 获取视频流
  getVideoStream(params) {
    return http.post(`/vss/hik/live`, params)
  },
  // 获取销售分布数据
  getSalesDistribution(params) {
    return http.post(`http://119.3.234.75:8085/sapmp/dp-market/getPullDownList`, params)
  },
  // 获取环境监测趋势数据
  getEnvironmentTrendData(params) { 
    return http.get('/business/greenhouse/dataTrend',params) // 可以返回一个json格式的数据或文件路径
  },
  // 登录
  login(params) {
    return http.post('/login',params) // 可以返回一个json格式的数据或文件路径
  },
  // 获取设备报警记录
  getWarnInfoList(params){
    return http.get('/business/equipmentWarning/list',params)
  },
  // 获取用户信息
  getUserInfo(){
    return http.get('/getInfo') 
  },
  // 获取实时天气信息
  getRealTimeWeatherData(){
    return http.post('/weather/getCaiYunRealtimeDataByPark') 
  },
  // 获取未来一周天气信息
  getCaiYunDataByPark(){
    return http.post('/weather/getCaiYunDataByPark') 
  },
  // 获取地块列表
  getPlotList(params){
    return http.get('/business/farmPlot/list',params) 
  },
  // 获取地块详情
  getPlotInfo(id) {
    return http.get(`/business/farmPlot/${id}`) 
  },
  // 查询园区下用户列表
  getUserListByPark(params){
    return http.get('/business/farmPark/getUserList',params) 
  },
  // 获取农事活动
  getActionList(params){
    return http.get('/business/action/list',params) 
  },
  // 获取字典表
  getDictList(dictType){
    return http.get('/system/dict/data/list',{dictType:dictType,pageSize:'1000',pageNum:'1'}) 
  },
  // 环境监测设备列表（含最新数据）
  getGreenHouseDataList(params){
    return http.get('/business/greenhouse/getLatestDataList',params) 
  },
  // 获取市场行情
  getMarkerPrice(params){
    return http.get('/business/marketPrice/marketPrice/list',params) 
  },
  // 获取气象站历史数据
  getWeatherListData(params){
    return http.get('/business/weatherStation/list',params) 
  },
  // 获取环境监测历史数据
  getGreenhouseListData(params){
    return http.get('/business/greenhouse/list',params) 
  },
  // 获取设备阈值列表
  getEquipmentThresholdList(params){
    return http.get('/business/equipmentThreshold/list',params) 
  },
  //获取投入品使用情况
  getMaterialUseDataList(params){
    return http.get('/business/materialUse/getGroup',params) 
  },
  // 获取土壤墒情趋势数据
  getSoilListData(params){
    return http.get('/business/soilMoisture/getLatestDataList',params) 
  },
  // 获取领导欢迎语
  getWelcomeList(params){
    return http.get('/system/notice/list',params)
  }

}
export default api;
// // 对接口时候用法
// this.$api.BCList(data).then(res => {
//   // 处理数据
//   console.log(res)
// })
